/**
 * Turns a schema's failure code into something an owner can read.
 *
 * The schemas raise codes (`invalid-nip`, `required`) rather than sentences,
 * because a zod schema has no `t()` and a message baked into it would be English
 * in a Polish form. Anything without a key of its own — a length overrun, say —
 * falls back to a generic line rather than showing zod's own English prose in a
 * field label.
 */
const KNOWN_CODES = [
  'required',
  'invalid-nip',
  'invalid-regon',
  'invalid-phone',
  'invalid-email',
  'invalid-url',
  'invalid-postal-code'
] as const

export const validationMessageKey = (code: string): string => {
  const known = (KNOWN_CODES as readonly string[]).includes(code)
  if (!known) return 'RESTAURANT_SETTINGS.VALIDATION.INVALID'
  return `RESTAURANT_SETTINGS.VALIDATION.${code.replace(/-/g, '_').toUpperCase()}`
}
